// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer__rectangleBox":"tagsContainer__rectangleBox--12zkq","tagsContainer__text":"tagsContainer__text--2Lbdb","tagsContainer__button":"tagsContainer__button--3d6T-"};